import * as React from 'react'

import { Box, NoticeBox, Skeleton } from '@factorialco/deprecated-design-system'
import { AtsHiringStageOptionsDocument } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { HiringStage } from 'modules/ats/hooks/hiringStages/useHiringStages'
import { getEditableStages } from 'modules/ats/lib/utils/hiringStages'

import { EditableStage, NonEditableStage } from './HiringPipelineStages'
import { NewStageButton } from './NewStageButton'

interface Props {
  onClose: () => void
  stages: HiringStage[]
}

export const EditHiringPipelinesSidepanel = ({ stages, onClose }: Props) => {
  const { data: hiringStageOptionsData, loading: loadingHiringStageOptions } = useQuery(
    AtsHiringStageOptionsDocument
  )

  const hiringStageOptions = hiringStageOptionsData?.ats.hiringStageOptionsConnection.nodes

  const editableStages = getEditableStages(stages)
  const stagePosition = (stages[0]?.position || 0) + 1

  const findPreviousStage = (position: number) => {
    return editableStages.find((stage) => stage.position === position - 1)
  }

  const findNextStage = (position: number) => {
    return editableStages.find((stage) => stage.position === position + 1)
  }

  const newStage = hiringStageOptions?.find((stage) => stage.name === 'new')
  const hiredStage = hiringStageOptions?.find((stage) => stage.name === 'hired')

  if (loadingHiringStageOptions) {
    return null
  }

  return (
    <Sidepanel
      open
      width="wide"
      title={i18n.t('ats.hiring_pipelines.settings.sidepanel.title')}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
    >
      <Box gap="s16">
        <NoticeBox message={i18n.t('ats.hiring_pipelines.settings.sidepanel.alert')} />
        {loadingHiringStageOptions ? (
          <Skeleton />
        ) : (
          <Box gap={'s16'}>
            {newStage && <NonEditableStage stageName={newStage.name} stageLabel={newStage.label} />}
            {hiringStageOptions && (
              <NewStageButton
                stages={editableStages}
                position={stagePosition}
                hiringStageOptions={hiringStageOptions}
              />
            )}
            {editableStages.map((stage) => (
              <Box key={`stage-item-${stage.id}`} gap="s16">
                <EditableStage
                  stage={stage}
                  stages={editableStages}
                  previousStage={findPreviousStage(stage.position)}
                  nextStage={findNextStage(stage.position)}
                />
                {hiringStageOptions && (
                  <NewStageButton
                    stages={editableStages}
                    position={stage.position + 1}
                    hiringStageOptions={hiringStageOptions}
                  />
                )}
              </Box>
            ))}
            {hiredStage && (
              <NonEditableStage stageName={hiredStage.name} stageLabel={hiredStage.label} />
            )}
          </Box>
        )}
      </Box>
    </Sidepanel>
  )
}
